import axios from "axios";
import { DBRequest } from "./dbRequest";

const invitationApiBaseUrl = (process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");

export function inviteUser({ email, firstName, lastName, onResponse, onError, onLoading }) {
  return DBRequest({
    path: "user/invite",
    method: "post",
    data: { email, firstName, lastName },
    onResponse,
    onError,
    onLoading,
  });
}

export function registerTenant({ name, description, onResponse, onError, onLoading }) {
  return DBRequest({
    path: "tenant/register",
    method: "post",
    data: { name, description },
    onResponse,
    onError,
    onLoading,
  });
}

export async function validateInvitation(email, token) {
  const response = await axios.get(
    `${invitationApiBaseUrl}/user/validate_invitation`,
    { params: { email, token } }
  );
  return response.data;
}

export async function acceptInvitation(email, token, password) {
  const response = await axios.post(
    `${invitationApiBaseUrl}/user/set-initial-password`,
    { email, token, password },
    { headers: { "Content-Type": "application/json" } }
  );
  return response.data;
}
